import { en } from '../locale';

export const brandingConfig = {
  company: {
    name: 'MONARQUE',
    tagline: en.branding.tagline,
    description: en.branding.description,
  },

  links: {
    website: '#',
    support: 'mailto:support@rogitex.com',
    documentation: 'http://localhost:5019/swagger',
    github: '#',
  },

  images: {
    logo: '/images/logo.png',
    logoSmall: '/images/logo-small.png',
    background: '/images/background.jpg',
    loginSidebar: '/images/login-bg.jpg',
    avatar: '/images/default-avatar.png',
  },

  colors: {
    primary: '#1e7ce2',
    secondary: '#dc004e',
    accent: '#1e7ce2',
    background: '#f5f5f5',
    surface: '#ffffff',
  },

  authColors: {
    background: '#1a1f2b',
    card: '#252a3d',
    inputBg: '#1a1f2b',
    border: 'rgba(255,255,255,0.08)',
    text: '#ffffff',
    muted: 'rgba(255,255,255,0.5)',
    button: '#2c3448',
    buttonHover: '#364057',
    outline: 'rgba(30,124,226,0.25)',
  },

  texts: {
    appTitle: 'MONARQUE',
    loginTitle: en.login.title,
    loginSubtitle: en.branding.loginSubtitle,
    dashboardTitle: 'Process',
    welcomeMessage: en.branding.welcomeMessage,
    footerText: 'MONARQUE • ROGITEX • ASP.NET Core + React',
  },

  features: [
    {
      title: en.branding.featureUsersTitle,
      description: en.branding.featureUsersDescription,
      icon: 'users',
      path: '/admin',
    },
    {
      title: en.branding.featureItemsTitle,
      description: en.branding.featureItemsDescription,
      icon: 'items',
      path: '/items',
    },
    {
      title: en.branding.featureJwtTitle,
      description: en.branding.featureJwtDescription,
      icon: 'security',
      path: '/login',
    },
  ],

  techStack: [
    'Backend ASP.NET Core 9.0',
    'Frontend React 18 + TypeScript',
    'Material-UI 5 Design System',
    'JWT Authentication',
    'Entity Framework Core',
    'Role-based Access Control',
    'API Rate Limiting',
    'Swagger Documentation',
  ],

  demo: {
    enabled: process.env.NODE_ENV === 'development',
    username: 'admin',
    password: 'Admin123!',
    showCredentials: process.env.NODE_ENV === 'development',
  },
};

export const { company, links, images, colors, texts, features, techStack, demo, authColors } =
  brandingConfig;
